import type { WidgetData } from '../model';

export const setPriorityData = (widgetData: WidgetData): Record<string, string> => {
  return {
    ...(widgetData.data?.url ? { link: widgetData.data.url } : {}),
    ...(widgetData.data?.urlStyle ? { 'show-fallback': widgetData.data.urlStyle } : {}),
    ...(widgetData.data?.linkText ? { 'link-text': widgetData.data.linkText } : {}),
  };
};
